import React, { forwardRef } from "react";
import { Row, Col } from "antd";
import {
  InputItem,
  SelectItem as SelectItemComponent,
  DatePickerItem,
  TextAreaItem,
} from "../../../components/forms/FormItems";
import { FormattedMessage } from "react-intl";
import {
  EmployeesSelect,
  MetaDataSelect,
  SubProjectsSelect,
} from "../../../components/forms/AutoCompleteFormItem";
import { BranchSelect } from "../../../components/forms/AutoCompleteFormItem";
import SwitchItem from "../../../components/forms/SwitchItem";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { isAllowedFeature } from "../../organization/organizationSlice";
import moment from "moment";
const staffFilter = { $and: [{ staff_member: true }] };

const AdditionalInfo = forwardRef((props, ref) => {
  const { activePatient, smallSpace } = props;
  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface smallSpace={smallSpace}>
        <FormHeader
          title={<FormattedMessage id="app.patients.additional_information" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="categories"
                  category="patient"
                  metadataName={"patient_categories"}
                  mode="multiple"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <div style={{ flex: 1 }}>
                  <MetaDataSelect
                    name="care_demands"
                    category="patient"
                    metadataName={"care_demands"}
                    mode="multiple"
                  />
                </div>
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="country"
                  category="patient"
                  metadataName={"countries"}
                  identfierId="english_name"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <DatePickerItem name="immigration_date" category="patient" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SettingsDataSelect
                  name="languages"
                  category="patient"
                  settingsdataName={"system_tables/languages"}
                  mode="multiple"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <EmployeesSelect
                  name="staff_worker_in_charge_id"
                  category="patient"
                  waitForFetch={!activePatient || !activePatient.branch}
                  extraParams={{
                    filter: staffFilter,
                    scopePrefix: `branches/${activePatient.branch}/`,
                  }}
                  items={
                    activePatient?.id &&
                    activePatient.staff_worker_in_charge && [
                      activePatient.staff_worker_in_charge,
                    ]
                  }
                  required={
                    process.env.REACT_APP_CONFIG === "matav" &&
                    activePatient.status_id === 1
                  }
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="num_people_at_home"
                  category="patient"
                  number={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="cleaning_hours_per_day"
                  category="patient"
                  number={true}
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SelectItemComponent
                  days={true}
                  name="days_in_day_center"
                  category="patient"
                  mode={"multiple"}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <BranchSelect name="day_center_branch_id" category="patient" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SettingsDataSelect
                  name="branch_extension_id"
                  category="patient"
                  settingsdataName={"system_tables/branch_extensions"}
                  waitForFetch={!activePatient || !activePatient.branch}
                  filterItems={(data) => {
                    return data.filter(
                      (i) => i.branch_id === activePatient.branch
                    );
                  }}
                  required={isAllowedFeature("accounting_tag")}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SubProjectsSelect
                  waitForFetch={!activePatient || !activePatient.branch}
                  name="subproject_id"
                  category="patient"
                  branchId={activePatient.branch}
                  required={isAllowedFeature("accounting_tag")}
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SettingsDataSelect
                  name="nursing_home_id"
                  category="patient"
                  settingsdataName={"system_tables/nursing_home"}
                  waitForFetch={!activePatient || !activePatient.branch}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SwitchItem name="has_time_clock" category="patient" />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <TextAreaItem
                  name="house_visit_comments"
                  rows={4}
                  category="patient"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <DatePickerItem
                  name="passing_date"
                  category="patient"
                  disabledDate={disabledDate}
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SettingsDataSelect
                  name="emergency_service_status_id"
                  category="patient"
                  settingsdataName={
                    "system_tables/patient_emergeycy_service_status"
                  }
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default AdditionalInfo;
